import React, { memo } from 'react'
import { Grid, IconButton } from '@mui/material'
import FaIcon from '../shared/FaIcon/FaIcon'
import {
  faMagnifyingGlass,
  faQrcode,
  faXmark
} from '@fortawesome/pro-light-svg-icons'

import { MEMBER_SEARCH_PROFILE_DISPATCH } from '../../store/reducers/members/memberSearch'
import Input from '../shared/inputs/Input'
import CustomIconButton from '../shared/buttons/CustomIconButton'

const MembersSearch = ({
  t,
  memberSearchProfile: { query },
  dispatchAction,
  onQrCodeClick,
  onResetSearchClick
}) => {
  return (
    <>
      <Grid item>
        <CustomIconButton
          onClick={onQrCodeClick}
          icon={faQrcode}
          variant='outlined'
          color='primary'
          iconStyles={{ width: 18 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Input
          id={MEMBER_SEARCH_PROFILE_DISPATCH.QUERY}
          placeholder={t('member.search-member-by-email-or-auth-id')}
          value={query}
          onChange={(value) =>
            dispatchAction(MEMBER_SEARCH_PROFILE_DISPATCH.QUERY, value)
          }
          size='small'
          endIcon={
            query ? (
              <IconButton onClick={onResetSearchClick} edge='end'>
                <FaIcon icon={faXmark} />
              </IconButton>
            ) : (
              <FaIcon icon={faMagnifyingGlass} />
            )
          }
        />
      </Grid>
    </>
  )
}

export default memo(MembersSearch)
